module.exports = __webpack_public_path__ + "static/img/CC-BY.551f254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cc/CC-BY.png
// module id = 6JHU
// module chunks = 16